import { useEffect, useState } from "react";
import { fetchBaseCodes } from "../../api/basecode";
import MessageBox from "../../../../components/message-box";

/**
 * 异响相关 BaseCode 拉取 hook（仅「能否重现异响=否」的通知文案），
 * 供异响编辑表单（Edit）与异响只读展示（Detail）共用。
 *
 * @param options.silent  为 true 时加载失败不弹提示（只读展示态用，避免详情页弹无意义 toast）。
 */
export default function useNoiseCodes(options?: { silent?: boolean }) {
  const silent = options?.silent ?? false;
  const [notice, setNotice] = useState("");

  useEffect(() => {
    fetchBaseCodes(["T1_NO_RECURRENT_NOTICE"], { rethrow: true })
      .then((map) => {
        setNotice((map.T1_NO_RECURRENT_NOTICE || [])[0]?.desc || "");
      })
      .catch(() => {
        // 通知文案加载失败：编辑态给出提示；只读展示态（silent）不打扰用户
        if (!silent) MessageBox.toast("异响选项加载失败，请稍后重试");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { notice };
}
